import React from "react";
import classes from "./index.module.scss";
import { Button, Icon, Modal } from "antd";
import { getSignInfo, signInEnd, SignInInfo } from "service/signIn";
import ResultMessage from "components/CourseComponents/ResultMessage";
import { errorMessage } from "service/service";
import useRequestFn from "utils/useRequestFn";
import SettingModal from "components/CourseComponents/SignIn/SettingModal";
import useModalHandler from "utils/useModalHandler";
import usePromiseCallback from "utils/usePromiseCallback";
import CountDown from "components/CourseComponents/CountDown";

interface SignInCountDownProps {
    weekTimeId: number;
    signInId: number;
    onStatusChange: () => void;
    signInfo: SignInInfo | null;
    onCountDown: () => void;
}

export default function SignInCountDown({
    weekTimeId,
    signInId,
    signInfo,
    onStatusChange,
    onCountDown
}: SignInCountDownProps) {
    const model = useModalHandler();
    const [callSignInEnd, endState] = useRequestFn(signInEnd);

    async function onTimeout() {
        if (!signInfo?.validityTime) return;

        try {
            const newSignInfo = await getSignInfo(signInId);

            if (signInfo.validityTime === newSignInfo.validityTime)
                await onSignInEndClick();
            else onStatusChange();
        } catch (e) {
            Modal.error({ content: errorMessage(e), getContainer });
        }
    }

    // 结束签到
    const onSignInEndClick = usePromiseCallback(async function () {
        try {
            await callSignInEnd(signInId);
            onStatusChange();
        } catch (e) {
            ResultMessage.error(errorMessage(e), { duration: 3000 });
        }
    });

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    return (
        <div className={classes.root}>
            <div className={classes.top}>
                {signInfo && (
                    <CountDown
                        key={signInfo.validityTime}
                        className={classes.time}
                        startTime={signInfo.startTime}
                        validityTime={signInfo.validityTime}
                        onEnd={onTimeout}
                        onCountDown={onCountDown}
                    />
                )}
                <button className={classes.settingBtn} onClick={model.open}>
                    <Icon type="setting" />
                </button>
            </div>

            <Button
                type="primary"
                ghost
                className={classes.button}
                onClick={onSignInEndClick}
                disabled={endState.loading}>
                <Icon type="poweroff" /> 结束签到
            </Button>

            <SettingModal
                visible={model.visible}
                onClose={model.close}
                weekTimeId={weekTimeId}
                onSuccess={onStatusChange}
                defaultData={signInfo}
                mode="projection"
            />
        </div>
    );
}
